import React from 'react'

import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import EditPlacesForm from './EditPlacesForm'
import ModalHeader from './ModalHeader'
import PlacesLoader from './_load/PlacesLoader'
import { useModalData } from '../../../components/modals/ModalsContext'
import LevelsLoader from '../editV2/sections/placeLevels/_load/LevelsLoader'

const EditPlacesModal = props => {
  const { type } = useModalData() || {}

  return (
    <ControlledModal fullScreen noPadding {...props}>
      <ModalHeader />
      <PermissionChecker module="place" name="edit">
        <PlacesLoader>
          <LevelsLoader type={type}>
            <EditPlacesForm />
          </LevelsLoader>
        </PlacesLoader>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default EditPlacesModal
